import { cloneDeep } from 'lodash';
import { createLogger } from 'shared/services/logger';
import uScopeApi from 'uScope/js/public-api';
import './uScope-extensions/PinDropNavigator/index';

const logger = createLogger('VIL');

(function ($) {
  /**
     * Lazy load imported globals.
     */
  const globals = ['Clone', 'leica', 'jsPAL', 'swfobject', 'flashVars', '_participant', 'confEvent'].reduce((obj, key) => {
    Object.defineProperty(obj, key, {
      get () {
        return window[key];
      }
    });
    return obj;
  }, {});

  /**
     * Constants
     */
  const eventNameSpace = '.VIL';
  const configurationStorage = [];

  /*
     * Singleton methods to call VIL
     */
  var __vilInstance__;
  var __dstInstance__ = null;
  var __accordionInstance__ = null;

  $.getVilInstance = function () {
    return __vilInstance__;
  };

  $.getDstInstance = function () { // so dst extention can cleanly get to the dst
    return __dstInstance__;
  };

  $.fn.vil = function (options, globalEvents) {
    var self = this;

    /*
    * This is the reserved internal variable only to be used for instantication and singleton get methofds
    */
    __vilInstance__ = self;
    self.events = globalEvents;

    $.setVilInstance = function (vilDiv) {
      __vilInstance__ = vilDiv;
      self = vilDiv;
      return __vilInstance__;
    };

    // VIL events
    var vilEventImageReady = 'vil_evIMAGEREADY';

    // if the selctor return null we need to stop immediatelly. the javascript at runtime will throw any errors
    if (self.length == 0) {
      return null;
    }
    var settings = configurationStorage[self.attr('id')] == null ? null : configurationStorage[self.attr('id')];

    self.uScopeStarted = false; // private internal boolean to track status of uScope: i.e, has been started yet?

    /*************************************************************************************************************
         PUBLIC FUNCTIONS -- this are the functions which are available from the instance.
         *************************************************************************************************************/

    self.getConfiguration = function () {
      return settings;
    };

    self.getAccordion = function (reload) {
      if (reload) {
        __accordionInstance__ = self.find('#' + settings.accordionSettings.divId).customaccordion(self);
      }
      return __accordionInstance__;
    };

    self.getDst = function (reload) {
      if (reload) {
        __dstInstance__ = self.find('#' + settings.dstSettings.divId).dst(self);
      }
      return __dstInstance__;
    };

    self.init = function (options) {
      // Configure a default resolved promise to handle all synchronous paths
      let resultPromise = $.Deferred().resolve().promise();

      settings = options;
      settings.parentDiv = self.parent();
      settings.workFlowDiv = settings.parentDiv.parent();
      settings.vilSettings.divId = '#' + this.attr('id');

      configurationStorage[self.attr('id')] = settings;

      // if running in a tab, disable all the tabs in that tab row
      // to prevent user from switching tabs before the dst and uScope
      // have fully initialized. tabs will be re-enabled in the us_evIMAGEREADY event handler
      if (settings.displayViewer && self.parent().hasClass('ui-tabs-panel')) {
        var tabs = self.parent().closest('.tabs');
        tabs.find('ul li').each(function (index, value) {
          tabs.tabs('disable', index);
          // if the <a> has an onclick handler, disable that too
          $(this).find('a.ui-tabs-anchor').each(function () {
            var onclick = $(this).attr('onclick');
            if (onclick && onclick != '') {
              $(this).attr('onclick', 'return false;' + onclick);
            }
          });
        });
      }
      // If a case (or other hierarchy) currentId is set, this code will load the slides for that case
      // possibly via an Ajax call. A promise is returned so callers creating a VIL can respond when the VIL is fully created
      if ((settings.currentId != '') && settings.displayDST) {
        if (settings.priorId.length) {
          resultPromise = loadSlides(settings.currentId, settings.priorId);
        } else {
          resultPromise = loadSlides(settings.currentId, null);
        }
      } else {
        // This section of code is used when dispalying a arbitrary list of slides rather than a case
        // settings.dstInfo should contain the list of slides - no ajax call to server is needed.
        // The default empty promise returned in this case is immediately resolvable
        if (settings.displayDST && (!$.isEmptyObject(settings.dstInfo))) {
          var accordion = self.getAccordion(true); // creates the singleton
          accordion.renderAccordion();
          renderDST(settings.dstInfo, true);
        }
        if (settings.displayViewer) {
          renderViewer();
        }
      }

      tabEventHandlers(); // attach to the tab related events
      removeUScopeEventHandlers(); // in case VIL is being reloaded, cancel any previous event handlers
      addUScopeEventHandlers(); // attach to the uScope events
      $(window).resize(function (e) {
        // this resize handler is firing on other than window:resize events. It's not obvious from the callstack why...
        if (e.target !== window) {
          return;
        }
        // prevent recursive calls to $(window).resize in IE8
        if (settings.ignoreResize == false) {
          self.resize('Resize');
        } else {
          settings.ignoreResize = false;
        }
      });

      if ($.conference) {
        $.getVilInstance().conference('init'); // init for conferencing
      }

      return resultPromise; // If an ajax call was made in load slides, this promise can be used to wait for VIL initialization completion
    };

    self.syncSlideMemosFromDst = function () {
      var dst = self.getDst();
      if (dst) {
        var vm = dst.getActiveViewModel();
        // At a minimum, loop through all the dst slides and update the memo field in the dstInfo
        if (vm) {
          $.each(vm.cases, function (index, theCase) {
            if (theCase.isPrimaryCase) {
              var currentSlides = vm.getSlides(vm);
              $.each(currentSlides, function (idx, slide) {
                // for each slide, find corresponding slide in settings.dstInfo and update memo
                if (!slide.isValidSlide || slide.isBlank) { return; }

                var matchingSlides = settings.dstInfo.cases[index].slides.filter(function (s) {
                  return s.imageId == slide.imageId;
                });

                if (matchingSlides.length > 0) {
                  matchingSlides[0].memo = slide.memoContent();
                }
              });
            };
          });
        }
      }
    };

    /*
         * attach event handlers to the Tab related events
         */
    var tabEventHandlers = function () {
      $(document).on('PALTabClosing.VIL', function (event, tabDivId) {
        // tabDivId is the id of the tab panel div associated with the closing tab.
        // if the closing tab panel div contains the VIL parent div, then close the DST in the div
        if ($(tabDivId).find($(settings.parentDiv)).length > 0) {
          closeDST();
        }
      });

      $(document).on('tabsshow.VIL', function (event, ui) {
        // Another tab has been chosen
        closeDST();
      });

      self.closest('.ui-tabs').on('tabsactivate.VIL', function (event, ui) {
        // refresh the VIL if required when the tab containing the VIL is shown
        if (settings.refreshRequired) {
          // if tab contains this VIL
          if ($(ui.panel).find(self).length > 0) {
            // remove and recreate the DST
            if (settings.displayDST && (!$.isEmptyObject(settings.dstInfo))) {
              if (typeof globals.jsPAL === 'object') {
                // will be closed in loadSlides(),
                // which also sets settings.refreshRequired = false
                globals.jsPAL.displayNotification('Updating ...', 10);
              }
              self.find('#' + settings.dstSettings.divId).empty();

              loadSlides(settings.currentId, null);
            } else {
              settings.refreshRequired = false;
            }
          }
        }
      });
    };

    function addUScopeEventHandlers () {
      if (settings.uScope.toolbarOptions.dscSetupBtn) {
        $(document).on(globals.confEvent.createBtn + eventNameSpace, function () {
          // Calling "createConfSetupDialog" *without* params creates a new conference.
          createConfSetupDialog();
        });
      }

      if (settings.uScope.toolbarOptions.nextPrevSlide) {
        // attaching VIL to uScope OpenNextSlide and OpenPrevSlide
        self.on('us_evOPENNEXTSLIDE.VIL', function (event, parms) {
          self.getDst().getActiveViewModel().moveNextSlide();
        });

        self.on('us_evOPENPREVSLIDE.VIL', function (event, parms) {
          self.getDst().getActiveViewModel().movePrevSlide();
        });
      }

      self.on('us_evIMAGECLOSE.VIL', function (event, parms) {
        var imageId = parms.imageId;
        self.getDst().getActiveViewModel().closeSlide(imageId);
      });

      self.on('us_evIMAGEREADY.VIL', function (e, parms) { // imageready event indicates newly opened image is up
        if (parms.status) {
          self.trigger(vilEventImageReady, parms);
        }
      });
      self.on('us_evAJAXERROR.VIL', function (e, parms) {
        // Let any global ajax error handlers take care of these (see master.js)
        if (!('ajaxError' in $._data(document, 'events'))) {
          eventAjaxError(parms);
        }
      });

      self.events.on('us:label:rotation-changed', (rotationDetails) => {
        self.getDst().rotateDstLabelsPopup(rotationDetails);
      });
    }

    function removeUScopeEventHandlers () {
      // remove all .VIL event handlers
      self.off(
        'us_evOPENNEXTSLIDE.VIL us_evOPENPREVSLIDE.VIL us_evIMAGECLOSE.VIL ' +
        'us_evIMAGENAVIGATED.VIL us_evANNOTCHANGE.VIL us_evIMAGEREADY.VIL ' +
        'us_evAJAXERROR.VIL ');
    }

    /*
     * uScope Event Handlers
     */

    // this event is triggered by uScope when an AJAX error occurs
    var eventAjaxError = function (parms) {
      // parms object:
      //   {imageId: @NUM, request: ImageServerRequest, jqXHR: jqXHR}
      let message = 'AJAX error: reqeust: ' + parms.request + ', status: ';
      if (!parms.jqXHR) {
        logger.warn(message + 'Unavailable');
      } else if (parms.jqXHR.readyState >= 4) {
        alert(message + parms.jqXHR.statusText);
      }
    };

    /*
         PRIVATE FUNCTIONS -- this are the functions which are available internally
         */

    var getDstInfo = function (primaryId, displayId) {
      // why are these side-effects here? -ccb

      settings.currentId = primaryId;
      var Parms = {TableName: settings.tableName, loadPriors: settings.dstSettings.loadPriors, PrimaryId: settings.currentId};
      // Add PAL module name if we are in HC (Network)
      if (globals.jsPAL && globals.jsPAL.getPALModuleName) {
        var tmpWorkFlow = globals.jsPAL.getPALModuleName();
        if (tmpWorkFlow.toLowerCase() !== 'unknown') {
          Parms.WorkFlow = tmpWorkFlow;
        }
      }

      if (displayId) {
        Parms.DisplayId = displayId;
        settings.priorId = displayId;
      } else {
        settings.priorId = '';
      }

      if (settings.simulate == true) {
        Parms.Simulate = 1;
      }

      return $.post('/DST_Get.php', Parms, null, 'json');
    };

    var loadSlides = function (primaryId, displayId) {
      var dfd = $.Deferred();
      var promiseSlidesLoaded = dfd.promise();
      var tableName = settings.tableName.toLowerCase();
      if (tableName == 'case' || tableName == 'project' || tableName == 'lesson') {
        getDstInfo(primaryId, displayId)
          .done(function (data) {
            if (data) {
              if (data.hasOwnProperty('Alert')) {
                logger.error('Error getting slide tray information: ' + data.Alert);
                settings.dstSettings.dstTitle += (': ' + data.Alert);
              }
              if (data.hasOwnProperty('DstInfo')) {
                settings.dstInfo = data.DstInfo;
              }
            } else {
              logger.error('Error getting slide tray information');
              settings.dstSettings.dstTitle += (': Error getting slide tray information.');
            }
          })
          .always(function (data) {
            // if this is the primary case, restore the initial lock mode
            if (!displayId) {
              settings.lockMode = settings.initialLockMode;
            } else if (primaryId !== displayId) {
              // else if a prior case, set lock mode to true
              settings.lockMode = true;
            }

            renderSlides(settings.dstInfo, !(displayId));
            if (typeof globals.jsPAL === 'object') { globals.jsPAL.closeNotification(); }
            settings.refreshRequired = false;
            dfd.resolve(data);
          })
          .fail(function (jqXHR, textStatus, errorThrown) {
            alert('Error getting DST: ' + textStatus + ' ' + errorThrown);
          });
      } else if (tableName == 'slide') {
        // If tablename is slide, then we ignore the dst_get and just load the list of slides as defined in dstInfo
        renderSlides(settings.dstInfo, true);
        if (typeof globals.jsPAL === 'object') { globals.jsPAL.closeNotification(); }
        settings.refreshRequired = false;
        setTimeout(() => {
          // resolve with empty object to indicate no errors (null would make more sense but backward compat.
          dfd.resolve({});
        });
      } else {
        dfd.reject({
          Alert: 'Invalid table name, "' + tableName + '".'
        });
      }

      return promiseSlidesLoaded;
    };

    var renderSlides = function (dstInfo, isPrimary) {
      var accordion;
      if (settings.displayDST) {
        accordion = self.getAccordion(true);
        accordion.renderAccordion(); // note that child accordion elements may not be added yet
        renderDST(dstInfo, isPrimary);
      }
      // render the uScope viewer, unless this is happening during the a refresh
      if (settings.displayViewer) {
        if (settings.refreshRequired === false) {
          renderViewer();
        }
      }

      // Determine which image to select/view
      if (settings.displayDST) {
        // clear out the global prevSelectedSlide if it is not present in uScope
        self.getDst().clearPrevSelectedSlide();
        // display the DST, which will select an image into uScope
        // if (isPrimary)
        self.getDst().selectDefaultSlide();
      }
    };

    /*
         * This is the function to render the DST from within VIL.
         * if the DST div is not initialized it will be created.
         */
    var renderDST = function (dstInfo, isPrimary) {
      var vil = self;
      if (vil.find('#' + settings.dstSettings.divId).length === 0) {
        self.getAccordion().importElements(); // add DST panel elements to accordion markup
      } else {
        saveDst(); // Save any changes to the currently displayed DST
      }

      var dst = self.getDst(true);
      // lock the DST if any of these are true:
      //  loading a prior case
      //  VIL is locked
      var lock = (!isPrimary) || (settings.lockMode);
      settings.dstSettings.lockMode = lock;

      // Clear any preset sizes to allow rendering to establish size
      dst.height('');
      vil.height('');
      settings.workFlowDiv.height('');

      dst.renderDST(dstInfo, settings.dstSettings, isPrimary);
      settings.dstSettings.height = dst.height(); // must be done after tray-handle adjustment
    };

    var renderViewer = function () {
      if (settings.flashViewer.flashVars != '') {
        self.append("<div id='webscope'></div>");
        var params = {
          menu: 'false',
          flashVars: settings.flashViewer.flashVars
        };
        var attributes = {};

        globals.swfobject.embedSWF(settings.flashViewer.movieSrc, 'webScope', '500', '500', '9.0.0', '/js/swfobject/expressInstall.swf', globals.flashVars, params, attributes);
      } else {
        var $uScope = self.find('#' + settings.uScope.setup.divId);
        var alreadyExists = $uScope.length;
        if (alreadyExists == 0) {
          $uScope = $('<div id=' + settings.uScope.setup.divId + '></div>');
          self.append($uScope);
          resize('Initial');
        }
        if (!self.uScopeStarted) {
          if (settings.uScope.images.length > 0) {
            // remove the images, they will be opened by pinning or selecting below
            var uscopeSlides = settings.uScope.images.splice(0);
          }
          createUScope(settings.uScope);
        }
        if (uscopeSlides) {
          var vm = self.getDst().getActiveViewModel();
          var dstSlides = vm.getSlides(vm);
          for (var us = 0; us < uscopeSlides.length; us++) {
            var uscopeSlide = uscopeSlides[us];
            for (var ds = 0; ds < dstSlides.length; ds++) {
              var dstSlide = dstSlides[ds];
              if (uscopeSlide.fullURL == dstSlide.fullURL) {
                if (uscopeSlide.isPinned) {
                  dstSlide.isMultiSlideSelected(true);
                } else {
                  vm.setSelectedSlide(vm, dstSlide);
                }
                break;
              }
            }
          }
        } else {
          selectUnpinnedSlideInTray(settings.uScope.images); // if an unpinned image specified the settings, make sure it is selected in the DST
        }

        self.uScope.lockDown(shouldLockuScope()); // lock uScope if running in locked mode or in ios mode
      }
    };

    var selectUnpinnedSlideInTray = function (images, notify) {
      if (typeof notify === 'undefined') { notify = true; }
      var unPinnedImages = images.filter(function (image) {
        return !image.isPinned;
      });
      // If the uscope settings have an image already opened, and it is not pinned, make sure it is selected in the DST
      if (unPinnedImages.length > 0) {
        var imagePath = unPinnedImages[0].imagePath;
        self.getDst().selectImageByImageId(imagePath.substring(1), notify);
      }
    };

    // Modes include 'Initial' and 'Resize'
    const resize = function (mode) {
      if (self.uScope && settings.displayViewer) {
        self.uScope.resize();
      }
    };

    /**
         * Save the entire slide tray, including positions, memos, etc.
         * @returns {deferred}
         */
    var saveDst = function () {
      var promise = {};
      // don't save the DST if a refresh is required, because the DST is no longer valid, and will be reloaded
      if (!settings.refreshRequired && !window.__isAIH) { // TIM: running in AIH mode, don't save the DST
        try {
          if (settings.dstSettings.lockMode === false) {
            var currentDst = self.getDst().serialize();
            promise = $.ajax('/DST_Save.php', {data: 'Data=' + currentDst, async: false}).done(function (response) {
              JSON.parse(response);
              // Errors have been caught/displayed
              self.getDst().clearModified(); // clear the DST modified flag
            }).fail(function (jqXHR, textStatus, errorThrown) {
              logger.error('Error saving DST: ' + textStatus + ' ' + errorThrown);
            });
          }
        } catch (e) {

        }
      }
      return promise;
    };

    var closeDST = function () {
      if (settings.displayDST) {
        var dstDiv = self.getDst();
        if (dstDiv.length) {
          if ($(dstDiv).is(':data(dialog)')) {
            dstDiv.close();
          }
        }
      }
    };

    /* Start Conferencing */
    var createConfSetupDialog = function (DscId, DscName) {
      globals.leica.pi.util.conference.createConfSetupDialog(DscId, DscName);
    };
    /* End Conferencing */

    var shouldLockuScope = function () {
      // uScope should be locked if running in locked mode or running on an ios device.
      // Note, at some point we may want to not lock when in iosMode, if so, remove it from the next statement
      return settings.lockMode || settings.iosMode;
    };
    /** End Conferencing **/

    /*************************************************************************************************************
         Public FUNCTIONS -- this are the functions which are available from the instance
         *************************************************************************************************************/

    self.VilImageSelected = function (slide, prevSlide, source) {
      // todo: DST should package the image info instead of sending the slide

      var viewerExists = self.find('#' + settings.uScope.setup.divId).length;
      if (viewerExists) {
        if (slide == null) {
          self.uScopeImageUpdate('add', settings.uScope.images); // cp-what does VIL think it is adding here? cb- is it for restoring when multiple case tabs open?
          self.uScope.lockDown(shouldLockuScope());
        } else {
          var image = {
            imagePath: slide.encodedImageId,
            fullURL: slide.fullURL,
            // if SaveAnnotation was read from CheckUserRights, then its value is '1' or '0'
            // if SaveAnnotation was read from GetData, then its value is true or false.
            // note GetData refers to 'SaveAnnotation' as 'CanEditAnnotation'
            saveAnnotations: (slide.SaveAnnotation == 1 || slide.SaveAnnotation === true || slide.CanEditAnnotation === true)
          };

          if (prevSlide == null || prevSlide == undefined || prevSlide.isBlank) {
            self.uScopeImageUpdate('add', {'image': image});
            self.uScope.lockDown(shouldLockuScope());
          } else {
            if (prevSlide.encodedImageId == '') {
              self.uScopeImageUpdate('replace', {'image': image}); // if previous was not a valid image, replace the unpinned image
            } else {
              self.uScopeImageUpdate('replace', {'image': {imagePath: prevSlide.encodedImageId}}, {'image': image});
            }
          }
        }
        tabStateUpdate();
      }
    };
    var tabStateUpdate = function () {
      // if VIL running in a tab, re-enable all the tabs that were disabled during initialization
      if (self.parent().hasClass('ui-tabs-panel')) {
        var tabs = self.parent().closest('.tabs');
        tabs.tabs('enable');
        tabs.find('ul li a.ui-tabs-anchor').each(function () {
          // remove any 'return false;' that were added to the onclick handlers
          var onclick = $(this).attr('onclick');
          if (onclick && onclick != '' && onclick.substring(0, 13) == 'return false;') { $(this).attr('onclick', onclick.substr(13)); }
        });
      }
    };

    self.loadSlides = function (primaryId, priorId) {
      return loadSlides(primaryId, priorId);
    };
    self.getCurrentId = function () {
      return settings.currentId;
    };
    self.getPriorId = function () {
      return settings.priorId;
    };
    self.saveDst = saveDst;

    // save the uScope state in settings, and then close uScope
    self.uScopeSaveAndClose = function () {
      settings.uScope.images = self.uScope.getImageState();
      removeUScopeEventHandlers();
      self.uScope.stop(); // stop uScope
      self.uScopeStarted = false;
      self.find('#' + settings.uScope.setup.divId).remove(); // remove the uscope div
    };
    // restore a uScope that was previously saved by uScopeSaveAndClose
    self.uScopeRestore = function () {
      // It has dependency on ViewerComponent.vue
      if ($(settings.uScope.setup.divId, self).length === 0) {
        // Remove the section.lbs-viewer-right-side which does not remove with uScope div removal.
        // and Update the uScope div wrapping inside section.lbs-viewer-right-side
        self[0].removeChild(self[0].lastChild);
        self.append($(`<section class="lbs-viewer-right-side"><div id=${settings.uScope.setup.divId} class="lbs-uscope-container"></div></section>`));
      }
      resize('Initial');
      if (!self.uScopeStarted) {
        createUScope(settings.uScope);
      }
      selectUnpinnedSlideInTray(settings.uScope.images, false); // if an unpinned image is specified the settings, make sure it is selected in the DST, but don't notify to avoid sending commands to reload
      self.uScope.lockDown(shouldLockuScope()); // lock uScope if running in locked mode or in ios mode
      addUScopeEventHandlers();
      resize('Resize');
    };

    /*
     *
     *  interface method for uScopeImageUpdate
     *
    */
    self.uScopeImageUpdate = function (action, jsonSettings, additionalJsonSettings) {
      return self.uScope.imageUpdate(action, jsonSettings, additionalJsonSettings);
    };

    // save the DST if it has been modified

    /**
         * Save the slide tray memos / arrangment if any have changed
         * @returns {deferred|window.$$.fn.vil.saveDSTifModified.promise|window.$$.fn.vil.saveDst.promise}
         */
    self.saveDSTifModified = function () {
      var promise = {};
      if (settings.displayDST) {
        var dst = self.getDst();
        if (dst.isModified()) {
          promise = saveDst();
        }
      }
      return promise;
    };

    // Note - These get/put settings methods used to clobber the dstInfo (overwritten with dstSettings),
    // which caused problems with conferencing when serializing the dstInfo to the DSC table
    // Fixed that problem by changeing these methods to assign the dstSettings to the VIL settings.dstSettings
    // Not sure of the full implications of this for code that calls these methods -cb 4.10.15
    self.getSettings = function () {
      var s = cloneDeep(settings);
      try {
        s.dstSettings = cloneDeep(self.getDst().getSettings());
      } catch (e) {
        // Swallow this error.
      }
      return s;
    };

    self.putSettings = function (newsettings) {
      settings = cloneDeep(newsettings);
      self.getDst().putSettings(cloneDeep(settings.dstSettings));
    };

    self.openConferenceInvite = function (confId, confName) {
      createConfSetupDialog(confId, confName);
    };

    self.refreshVILRequired = function () {
      settings.refreshRequired = true;
    };

    self.resize = resize;

    self.initializeAccordion = function (activeIndex, vm) {
      self.getAccordion().activatePanel(activeIndex);
    };

    self.uScopeResize = function () {
      self.uScope.resize();
    };

    function createUScope (uScopeSettings) {
      self.uScope = uScopeApi.createUScope(uScopeSettings);
      self.uScopeStarted = true;
    }

    let startupPromise;
    self.getStartupPromise = () => {
      return startupPromise;
    };

    if (typeof options === 'object' && options !== null) {
      startupPromise = self.init(options);
    }

    // return "self" to facilitate chaining.
    return self;
  };
})(window.$);



// WEBPACK FOOTER //
// ./src/vil/jquery.vil.js